export default {
  common: {
    chiller: "冷机",
    chilledWaterPump: "冷冻水泵",
    coolingTower: "冷却塔",
    nextStep: "下一步",
    previousStep: "上一步",
    objective: "项目目标",
    preRetrofit: "改造前",
    postRetrofit: "改造后",
    retrofitSetup: "改造设置",
    equipmentRated: "设备铭牌",
    retrofitSummary: "改造信息汇总",
    cwp: "冷凝水泵",
    condenderWaterPump: "冷冻水泵",
    chwp: "冷冻水泵",
    ct: "冷却塔",
    other: "其他",
    otherEquipment: "其他设备",
    chillerOneNos: "冷机 (1 台)",
    condenderWaterPumpOneNos: "冷凝水泵 (1 台)",
    chilledWaterPumpOneNos: "冷冻水泵 (1 台)",
    coolingTowerFanOneNos: "冷却塔风扇 (1 台)",
    dryCooler: "干式冷却器",
    controlOptimization: "控制优化",
    commonHeader: "共用头部",
    dedicatedOneOnOne: "专用的 (1-1)",
    pleaseInput: "请输入",
    pleaseEnterHere: "请在此处输入",
    cancel: "取消",
    Confirm: "确认",
    years: "年",
    noProjectInfo: "未找到项目信息",

    pleaseInputData: "请输入数据",
    systemOptionRequired: "请输入系统选项",
    proposedEquipmentRequired: "请输入建议设备"
  },
  objective: {
    projectObjective: "项目目标",
    chillerEfficiency: "冷机效率",
    chillerPlantEfficiency: "冷水机组效率",
    heatingEfficiency: "热泵效率",
    heatingPlantEfficiency: "热泵机组效率",
    chillerHeatingEfficiency: "冷机于热泵效率",
    pleaseSelectAProjectObjective: "请选择一项项目目标",
    oneOnOne: "( 1 - 1 )",
    oneOnOneOrPlant: " ( 1 - 1 ) 或 机组",
    projectName: "当前项目名称",
    doYouWantSave: "关闭本页前，你想将数据保存到云端吗 ?",
    start: "开始",
    quickNavigation: "快捷导航",

    establishBaseline: "建立基线",
    profile: "简介资料",
    siteObservation: "现场观察",
    equipmentSpecification: "设备规范",
    baselineInput: "基线输入",
    summary: "汇总",
    generateReport: "生成报告",

    finalizeYourProposal: "确定你的提案",
    retrofitSetup: "改造设置",
    equipmentRated: "设备铭牌",
    financialAnalysis: "财务分析",
    proposedConfig: "建议配置"
  },
  setup: {
    systemOption: "系统选项",
    chillerOnly: "冷机",
    chillerWithAssociatedEquipment: "冷机及相关设备",
    controlOnly: "控制",
    proposedLayout: "建议布局",
    series: "串联",
    parallel: "并联",
    proposedEquipment: "建议设备"
  },
  rated: {
    newEquipment: "添加设备",
    ratedInputPower: "额定输入功率",
    ratedCoolingCapacity: "额定制冷量",
    chillerLabel: "冷机名",
    type: "类型",
    chillerBrandModel: "冷水机品牌和型号",
    yearInstalled: "安装年份",
    ratedDesignFlowRate: "额定设计流量",
    pressureHead: "压头",
    vfd: "是否安装了变频器",
    yes: "有",
    no: "无",
    noofFansCT: "风扇数量/CT",
    equipmentLabel: "设备名称",
    category: "类别",
    brand: "品牌",
    otherEquipment: "其他设备",
    inputEcatPerformanceData: "输入Ecat性能数据",
    load: "负荷",
    coolingLoad: "冷负荷",
    inputPower: "输入功率",
    chillerWaterPumpLabel: "冷水泵名称",
    ratedMotorFrequency: "额定电机频率",
    minimumMotorFrequency: "最小电机频率",
    motor: "电机 (kW)",
    applicableChiller: "适用冷水机组",
    condenserWaterPumpLabel: "冷凝水泵名称",
    coolingTowerLabel: "冷却塔名称",
    ratedFanFrequency: "额定风扇频率",
    minimumFanFrequency: "最小风扇频率",
    totalRatedFanPowerPerCT: "每个CT的总额定风扇功率",
    heatRejectionCapacityPerCT: "每个CT的散热能力",
    chillerLabelRequired: "填写冷机名",
    yellowBlockRequired: "黄色输入框必填",
    labelRequired: "设备名称必填",
    maximumQuantity: "已到数量上限"
  },
  summary: {
    chooleYourPreference: "选择方案偏好",
    higherEfficiencyImprovement: "更高的能效提升",
    lowerInvestment: "更低的投资",
    higherCostSaving: "更低的成本",
    shorterPaybackPeriod: "更短投资回收期",
    option: "方案选项",
    efficiencyImprovement: "提高能效",
    returnOnInvestment: "投资回报",
    costSavingsPerYear: "每年节省成本",
    paybackPeriod: "回报周期",
    optionDetails: "方案选项详情",
    postRetrofitEfficiency: "改造后能效",
    totalEnergySavingsPerYear: "每年总节能量",
    investmentAnalysis: "投资分析",
    capex: "资本支出",
    sellingPrice: "售价",
    chillerCooling: "冷机",
    chillerHeatPump: "热泵",
    calculate: "计算",
    proposedConfig: "建议配置",
    projectIntroduction: "项目简介",
    assumptions: "前提",
    chillerPlant: "冷机机组",
    chillerPlantConfig: "冷机机组配置",
    peakBuildingCoolingLoad: "建筑冷负荷峰值",
    designChilledWaterSupplyTemp: "设计冷冻水供水温度",
    designCondenserWaterSupplyTemp: "设计冷凝器供水温度",
    energyConservationMeasures: "节能措施",
    pumpingConfig: "泵机配置",
    designFlowRate: "设计流量",
    designPressureHead: "设计压头",
    vfdFitted: "VFD 拟合值",
    chillerConfig: "冷机配置",
    condenserWaterPump: "冷凝水泵",
    coolingTowerConfig: "冷却塔配置",
    heatRejectionCapacity: "排热能力",
    designCoolingTowerApproach: "冷却塔设计方法",
    generateReport: "生成报告",
    confirmCalculation: "确认计算",
    doYouNeedCalculationAgain: "系统发现已经存在计算结果，你是否需要重新进行计算",
    recalculate: "重新计算",
    coolingTower: "冷却塔",
    chiller: "冷机",
    chilledWaterPump: "冷冻水泵",

    fillValidNumericalValue: "请输入一个有效数值"
  },
  profileMap: {
    associatedChiller: "关联冷机",
    associatedCWP: "关联 CWP",
    associatedCHWP: "关联 CHWP",
    associatedCT: "关联冷却塔",
    profileId: "配置文件ID",
    donotNeedmanipulate: "自动模式下，您无需对配置文件进行操作5.",

    automatic: "自动关联",
    manual: "手动关联",
    pathAndMethod: "生成方法",
    months: "包含月",
    running: "运行",
    daysPerMonth: "天 / 月",
    chiller: "冷机"
  }
}



// WEBPACK FOOTER //
// ./src/locale/post/zh.js